<template>
    <div v-if="getPermission.settings.view">  


    <gst-confirm-load-form ref="GSTConfirmLoadChange" mode="CHANGE"/>


    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>Load Pictures</h3>
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>Photo Type: {{getPhotoName(p)}}</p>
            <p>Stage info: {{p.photoKey.slice(0, -3)}}</p>
          </view-image>
        </calling-api>
      </md-dialog-content>

      
      <md-dialog-actions>
        <!-- <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"/> -->
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>




    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-15">
            
            <div class = "inputBox">
              <auto-complete-master-data-select
                          label="Sales Office"
                          display-type="idOnly"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_SALEOFFICE')"
                          :init-value-id="searchRequest.salesOffice"
                          :on-item-changed="handleOfficeChanged">
              </auto-complete-master-data-select>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo" />
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Customer Order</label>
                <md-input v-model="searchRequest.customerOrder"/>
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Pick up Location</label>
                <md-input v-model="searchRequest.pickupLocationCode" />
              </md-field>
            </div>
          </div>


          <div v-if="active" class="md-layout-item md-size-15">
             <div class = "inputBox">
              <auto-complete-master-data-multiple-select
                  label="Delivery Type"
                  :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_STAGE_STATUS')"
                  v-model="searchRequest.deliveryType"
              />
            </div>

             <div class = "inputBox">
              <md-field>
                <label>Chassis #</label>
                <md-input v-model="searchRequest.chassisNo" />
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Booking #</label>
                <md-input v-model="searchRequest.bookingNo"/>
              </md-field>
            </div>


            <div class = "inputBox">
              <md-field>
                <label>Destination</label>
                <md-input v-model="searchRequest.deliverLocationCode" />
              </md-field>
            </div>
          </div>




          <div v-if="active" class="md-layout-item md-size-15">
             <div class = "inputBox">

               <auto-complete-master-data-select

              label="Status"
                  display-type="idOnly"
                  :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                  :init-value-id="searchRequest.loadStatus"
                  :on-item-changed="handleLoadStatusChanged">
              </auto-complete-master-data-select>
            </div>


            

             <div class = "inputBox">
              <md-field>
                <label>Reference Number</label>
                <md-input v-model="searchRequest.referenceNo" />
              </md-field>
            </div>


            <div class = "inputBox">
              <md-field>
                <label>Carrier Name</label>
                <md-input v-model="searchRequest.carrier" />
              </md-field>
            </div>

            


          </div>


          

          <div v-if="active" class="md-layout-item md-size-15">

            <div class = "inputBox">
              <md-field>
                <label>Load Key</label>
                <md-input v-model="searchRequest.loadKey"/>
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>GST DO</label>
                <md-input v-model="searchRequest.deliveryOrder" />
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Route</label>
                <md-input v-model="searchRequest.route" />
              </md-field>
            </div>


            <div class = "inputBox">
              <auto-complete-master-data-multiple-select
                  label="Chassis Vendor"
                  :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_CHASSIS')"
                  v-model="searchRequest.chassisVendor"
              />
            </div>



            <div class = "inputBox">
              <md-field>
                <label>Confirmed By</label>
                <md-input v-model="searchRequest.confirmBy" />
              </md-field>
            </div>


            <div class = "inputBox">
              <md-field>
                <label>Changed By</label>
                <md-input v-model="searchRequest.changedBy" />
              </md-field>
            </div>


          </div>

          <div  v-if="active" class="md-layout-item md-size-20">
             <div class = "inputBox" >
              <datepicker v-model="searchRequest.deliveryStartDate.startDate" >
                <label>Delivery Start Date</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.deliveryEndDate.startDate" >
                <label>Delivery End Date</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.chzStartDate.startDate" >
                <label>CHZ Start Date</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.chzEndDate.startDate" >
                <label>CHZ End Date</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.confirmDate.startDate" >
                <label>Confirm Date</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.changeDate.startDate" >
                <label>Chnage Date</label>
              </datepicker>
            </div>
          </div>


          <div  v-if="active" class="md-layout-item md-size-20">
             <div class = "inputBox" >
              <datepicker v-model="searchRequest.deliveryStartDate.endDate" >
                <label>To</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.deliveryEndDate.endDate" >
                <label>To</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.chzStartDate.endDate" >
                <label>To</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.chzEndDate.endDate" >
                <label>To</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.confirmDate.endDate" >
                <label>To</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.changeDate.endDate" >
                <label>To</label>
              </datepicker>
            </div>
          </div>

          <div v-if="getPermission.ccic.edit" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/gstConfirm/WebSearchConfirmLoads', '/api/w/excel/generate','/api/w/gstConfirm/WebUpdateConfirmLoads','/api/w/gst/WebCopyDeleteStage', '/api/w/gst/updateyardstage','/api/w/ccic/photo/get','/api/w/users']">
              <callingApiCenter path=" /api/w/gst/loadlist/create" :not-display-error="true">
              <md-button class="md-raised custButton " :disabled="!canChange" @click="doChange" ><span class="icons-center material-icons">create</span> Maintain</md-button>
              <md-button class="md-raised custButton " :disabled="!canUnderCheck" @click="doUC"><span class="icons-center material-icons">create</span> Under Check</md-button>
                  <md-button class="md-raised custButton " :disabled="!canUnUnderCheck" @click="doCF"><span class="icons-center material-icons">create</span> Check finish</md-button>
                  <md-button class="md-raised custButton " :disabled="!canConfirm" @click="doLC"><span class="icons-center material-icons">create</span> Confirm</md-button>
                  <md-button class="md-raised custButton " :disabled="!canUnConfirm" @click="doLU" ><span class="icons-center material-icons">create</span> Unconfirm</md-button>
                  <md-button class="md-raised custButton " :disabled="!canEdit" @click="doCockPit"><span class="icons-center material-icons">create</span> Cockpit</md-button>
                  <md-button id = "searchTag"  @click="doSearch" class=" custButton btn-search-special-form-loads md-primary md-raised">Search</md-button>
                  <md-button   class="md-raised custButton" @click="doClear">Clear</md-button>
             <input class = "custSearchBar" type="text"
                    placeholder="Searching Term"
                    v-model="filter"
                    />
            <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

        <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                  </tr>
                  <th class="header-cell w2"></th>
                    <th class="header-cell center w5" >Delivery Type</th>
                    <th class="header-cell center w5" >Sales Office</th>
                    <th class="header-cell center w5" >Load Key</th>
                    <th class="header-cell center w5" >Load Status</th>
                    <th class="header-cell center w5" >Container#</th>
                    <th class="header-cell center w5" >Chassis#</th>
                    <th class="header-cell center w5" >Own Chassis</th>
                    <th class="header-cell center w5" >Street Turn</th>
                    <th class="header-cell center w5" >Carrier</th>
                    <th class="header-cell center w5" >Chassis Vendor</th>
                    <th class="header-cell center w5" >Chassis Days</th>
                    <th class="header-cell center w5" >CHassis days Paid Out</th>
                    <th class="header-cell center w5" >CHassis days Charge Back</th>
                    <th class="header-cell center w5" >CHZ start Date</th>
                    <th class="header-cell center w5" >CHZ end Date</th>
                    <th class="header-cell center w5" >Out Gate Photo</th>
                    <th class="header-cell center w5" >In Gate Photo</th>
                    <th class="header-cell center w5" >Total Waiting Hours</th>
                    <th class="header-cell center w5" >Driver waiting time paid out</th>
                    <th class="header-cell center w5" >Driver waiting time Charge Back</th>
                    <th class="header-cell center w5" >Delivery End Date</th>
                    <th class="header-cell center w5" >Pictures</th>
                    <th class="header-cell center w5" >Additional Cost to Driver</th>
                    <th class="header-cell center w5" >Additional Cost to Customer</th>
                    <th class="header-cell center w5" >Picture for Additional Docs</th>
                    <th class="header-cell center w5" >PREPULL</th>
                    <th class="header-cell center w5" >DROPOFF</th>
                    <th class="header-cell center w5" >PIER PASS</th>
                    <th class="header-cell center w5" >BOBTAIL</th>
                    <th class="header-cell center w5" >DRY RUN</th>
                    <th class="header-cell center w5" >Load Remark</th>
                    <th class="header-cell center w5" >GST DO</th>
                    <th class="header-cell center w5" >GST DO Item</th>
                    <th class="header-cell center w5" >Cust Order</th>
                    <th class="header-cell center w5" >Booking #</th>
                    <th class="header-cell center w5" >Reference #</th>
                    <th class="header-cell center w5" >Route#</th>
                    <th class="header-cell center w5" >Pickup Location</th>
                    <th class="header-cell center w5" >Delivery Location</th>
                    <th class="header-cell center w5" >Container Size</th>
                    <th class="header-cell center w5" >Confirmed By</th>
                    <th class="header-cell center w5" >Confirmed Date</th>
                    <th class="header-cell center w5" >Changed By</th>
                    <th class="header-cell center w5" >Changed Date</th>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                     <td class="body-cell w2 ">
                      <md-checkbox v-model="item.selected">
                        <span v-if="hasBeenChanged(item)">*</span>
                      </md-checkbox>
                    </td>
                    <td class="body-cell excelBox w5">{{item.deliveryType}}</td>
                    <td class="body-cell excelBox w5">{{item.salesOffice}}</td>
                    <td class="body-cell excelBox w5">{{item.loadKey}}</td>
                    <td class="body-cell excelBox w5">{{item.loadStatus}}</td>
                    <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                    <td class="body-cell excelBox w5">{{item.chassisNo}}</td>
                    <td class="body-cell excelBox w5">{{item.ownChassis}}</td>
                    <td class="body-cell excelBox w5">{{item.source}}</td>
                    <td class="body-cell excelBox w5">{{item.carrier}}</td>
                    <td class="body-cell excelBox w5">{{item.chassisVendor}}</td>
                    <td class="body-cell excelBox w5">
                      {{item.chassisDays != null ? item.chassisDays : getDifferentDate(item.chzEndDate, item.chzStartDate)}}</td>
                    <td class="body-cell excelBox w5">{{item.chzDaysPaidOut}}</td>
                    <td class="body-cell excelBox w5">{{item.chzDaysChargeBack}}</td>
                    <td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.chzEndDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.outGatePhotos == null ? '' : '&#x2713;'}}</td>
                    <td class="body-cell excelBox w5">{{item.inGatePhoto == null ? '' : '&#x2713;'}}</td>
                    <td class="body-cell excelBox w5">{{item.totalHours}}</td>
                    <td class="body-cell excelBox w5">{{item.waitingTimePaidOut}}</td>
                    <td class="body-cell excelBox w5">{{item.waitingTimeChargeBack}}</td>
                    <td class="body-cell excelBox w5">{{item.deliveryEndDate | date}}</td>
                    <td class="body-cell excelBox w5">
                     <a href="" @click.prevent="toggleItemPhoto(item)">{{item.pictures}} photos</a>
                      </td>
                    <td class="body-cell excelBox w5">{{item.additionalCostToDriver}}</td>
                    <td class="body-cell excelBox w5">{{item.additionalCostToCustomer}}</td>
                    <td class="body-cell excelBox w5">{{item.picturesAdd}}</td>
                    <td class="body-cell excelBox w5">{{item.prepull}}</td>
                    <td class="body-cell excelBox w5">{{item.dropoff}}</td>
                    <td class="body-cell excelBox w5">{{item.pierpass}}</td>
                    <td class="body-cell excelBox w5">{{item.bobtail}}</td>
                    <td class="body-cell excelBox w5">{{item.dryrun}}</td>
                    <td class="body-cell excelBox w5">{{item.loadRemark}}</td>
                    <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>
                    <td class="body-cell excelBox w5">{{item.deliveryItem}}</td>
                    <td class="body-cell excelBox w5">{{item.customerOrder}}</td>
                    <td class="body-cell excelBox w5">{{item.bookObl}}</td>
                    <td class="body-cell excelBox w5">{{item.referenceNo}}</td>
                    <td class="body-cell excelBox w5">{{item.route}}</td>
                    <td class="body-cell excelBox w5">
                       <master-data-display group="GST_LOCATION" :tag-id="item.pickupLocationCode"/>
                    </td>
                    <td class="body-cell excelBox w5">
                       <master-data-display group="GST_LOCATION" :tag-id="item.deliverLocationCode"/>
                    </td>
                    <td class="body-cell excelBox w5">{{item.ctnrType}}</td>
                    <td class="body-cell excelBox w5">{{item.confirmBy}}</td>
                    <td class="body-cell excelBox w5">{{item.confirmDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.changeBy}}</td>
                    <td class="body-cell excelBox w5">{{item.changeDate | date}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    </div>





</template>


<style scoped>



.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.spaceLine {
  margin-bottom: 10px;
}

.popuptext {
  visibility: show;
  width: 160px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;
}

.excelBox {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  
}

.excelBoxTB {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    margin-right: 5px;
  
}

.excelBoxLeft {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 5px 5px 5px 5px;
    margin-top: 5px;
}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 6px 6px 6px 6px;
    margin-top: 5px;
    background-color: #e0eff7;
      
}

.selected {
     background: #726a95;
}

.tableW {
    height: 40px;
}

.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}


.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}

.md-menu {
  padding: 0;
  padding: 0;

}

.custButton {
    margin: 10px;
    width: 110px;
    height: 40px;
    line-height:40px;
    font-size: 0.8rem;
   
}

.custMenuButton {
    
    width: 110px;
    height: 40px;
    line-height:45px;
    font-size: 0.9rem;
    align-self: center;
   
}

.custSearchBar{
      margin: 10px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}


.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}



</style>



<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  //import api from "../api";
  import { newAPIPost } from '../api';
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import gstConfirmLoadForm from '../components/GSTconfirmLoadsForm.vue';
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";



    const getInitSearch = () => ({
    salesOffice: null,
    containerNo: null,
    customerOrder: null,
    pickupLocationCode: null,
    deliveryType: null,
    chassisNo: null,
    bookingNo: null,
    deliverLocationCode: null,
    loadStatus: null,
    referenceNo: null,
    chassisVendor: null,
    carrier: null,
    loadKey: null,
    deliveryOrder: null,
    freightType: null,
    route: null,
    confirmBy: null,
    changedBy: null,
    deliveryStartDate: {
      startDate: null,
      endDate: null,
    },
    deliveryEndDate: {
      startDate: null,
      endDate: null,
    },
    chzEndDate: {
      startDate: null,
      endDate: null,
    },
    chzStartDate: {
      startDate: null,
      endDate: null,
    },
    confirmDate: {
      startDate: null,
      endDate: null,
    },
    changeDate: {
      startDate: null,
      endDate: null,
    },

    createdAt: {
      startDate: null,
      endDate: null,
    },

    
    selected: false,
  });

  export default {

    data: () => ({
      searchRequest: getInitSearch(),
      active: false,
      items: [],
      dialog: {
        isShowing: false,
      },
      usersToSearch: [],
      modalMessage: "",  
      isWarning: false,
      sortStatus: true,
      filter:"",
      containerCopy: false,
      photos: [],
      testphotos: [],
      photoZipFileName: '',
      filePrefixForEachFile: '',
      isPictureModalShowing: false,
    }),


    components: {
      AutocompleteCcicLocationSelect,
      CcicPhotoForm,
      gstConfirmLoadForm,
      callingApiCenter,
    },

    watch: {
      getGSTLoad(val) {
        this.updateItems(val);
      },
    },

    computed: {
    ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getGSTLoad',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.salesOffice).includes(term) ||
                 this.includeNull(row.loadKey).includes(term) ||
                 this.includeNull(row.loadStatus).includes(term)||
                 this.includeNull(row.stageStatus).includes(term)||
                 this.includeNull(row.stageType).includes(term)||
                  this.includeNull(row.containerNo).includes(term)||
                  this.includeNull(row.chassisNo).includes(term)||
                  this.includeNull(row.carrier).includes(term);
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        if (this.getSelectedItems.length != 0)
        {
           return true
        }
        else
        {
          return false
        }
        
         //return this.getSelectedItems.length === 1 ;
      },


      canChange() {
        if (this.getSelectedItems.length === 1)
        {
          if (this.getSelectedItems[0].loadStatus != 'LDC' )
          {
              return true
          }
           
        }
        else
        {
          return false
        }
      },


      

      canConfirm() {
        if (this.getSelectedItems.length === 1)
        {
          if (this.getSelectedItems[0].loadStatus != 'LDC' 
          && this.getSelectedItems[0].loadStatus != 'LUC' )
          {
              return true
          }
           
        }
        else
        {
          return false
        }
      },


      canUnConfirm() {
        if (this.getSelectedItems.length === 1)
        {
          if (this.getSelectedItems[0].loadStatus == 'LDC' )
          {
              return true
          }
           
        }
        else
        {
          return false
        }
      },

      canUnderCheck() {
        if (this.getSelectedItems.length === 1)
        {
          if (this.getSelectedItems[0].loadStatus != 'LDC' 
          && this.getSelectedItems[0].loadStatus != 'LUC' )
          {
              return true
          }
           
        }
        else
        {
          return false
        }
      },




      canUnUnderCheck() {
        if (this.getSelectedItems.length === 1)
        {
          if (this.getSelectedItems[0].loadStatus == 'LUC' )
          {
              return true
          }
           
        }
        else
        {
          return false
        }
      },






    },

    async mounted() {
      
       // this.$el.querySelector('#expand-button').click();
        const cachedSearchRequest = this.$store.state.importLoad.searchRequest;
        this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        this.$el.querySelector('#searchTag').click();
        this.updateItems(this.getGSTLoad);

    },

     methods: {


       handleLoadStatusChanged(id) {
        this.searchRequest.loadStatus = id;
      },



        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
          this.active = !this.active;
        },

        hasBeenChanged(item) {
        const lhs = _(this.getGSTLoad)
          .find(it => it.loadKeyWithStageNo === item.loadKeyWithStageNo);
        if (lhs) {
          return (moment(lhs.apptDate).format() !== moment(item.apptDate).format())
            || (lhs.appointment !== item.appointment)
            || (lhs.driverId !== item.driverId)
            || (lhs.truckId !== item.truckId)
            || (lhs.dispatcherInstruction !== item.dispatcherInstruction)
            || (lhs.costRelevant !== item.costRelevant)
            || (lhs.freightType !== item.freightType)
            || (lhs.stageStatus !== item.stageStatus)
            || (lhs.containerNo != item.containerNo)
            || (lhs.pickupLocationCode != item.pickupLocationCode)
            || (lhs.deliverLocationCode != item.deliverLocationCode);
        }
        return false;
      },

      toggleContainerCopy(element){
          this.containerCopy = true;
          setTimeout(() => {  this.containerCopy = false; }, 2000);
          var el = document.createElement('textarea');
          el.value = element;
          el.setAttribute('readonly', '');
          el.style = {position: 'absolute', left: '-9999px'};
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
      },

      updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
        },


      handleOfficeChanged(id) {
        this.searchRequest.salesOffice = id;
      },


      async doChange(){
        const request = this.getSelectedItems[0];
        this.$refs.GSTConfirmLoadChange.openDialog(request);
      },


      async doUC() {
        const editItem = this.getSelectedItems;
        const requests = _(editItem)
          .chain()
          .map(it => ({
            salesOffice: it.salesOffice,
            loadKey: it.loadKey,
            status: it.loadStatus,
          })).value();
         //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
           action:"UC",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },


      async doCF() {
        const editItem = this.getSelectedItems;
        const requests = _(editItem)
          .chain()
          .map(it => ({
            salesOffice: it.salesOffice,
            loadKey: it.loadKey,
            status: it.loadStatus,
          })).value();
         //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
           action:"CF",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },


       async doLC() {
        const editItem = this.getSelectedItems;
        const requests = _(editItem)
          .chain()
          .map(it => ({
            salesOffice: it.salesOffice,
            loadKey: it.loadKey,
            status: it.loadStatus,
          })).value();
         //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
           action:"LC",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },

      async doLU() {
        const editItem = this.getSelectedItems;
        const requests = _(editItem)
          .chain()
          .map(it => ({
            salesOffice: it.salesOffice,
            loadKey: it.loadKey,
            status: it.loadStatus,
          })).value();
         //api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", {
         newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", {
           action:"LU",
           status:requests,
         })
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },

      doCockPit() {
        const request = this.getSelectedItems
        request.forEach((it) => {
          it.change = false;
          it.chassisStartLocal = dateFormat.gstDateFormat(it.chzStartDate);
          it.chassisEndLocal = dateFormat.gstDateFormat(it.chzEndDate);

        });
        this.$router.push({ 
            name: "cockpitLoad" , 
            params: request})
      },



      doSearch() {
        this.active = false;
        this.$store.dispatch('gstLoad', this.searchRequest);
       },


       doEdit() {
        this.getSelectedItems.forEach((it) => {
          it.editing = true;
        });
      },


      doClear(){
          this.items = this.getGSTLoad
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      async toggleItemPhoto(item) {
        this.isPictureModalShowing = true;
        this.photos = item.pictureList;
        
        // this.photoZipFileName = `${item.application.bookingNo}_${item.application.poNo}_${item.containerNo}.zip`;
        // this.filePrefixForEachFile = `${item.containerNo}-`;

      },

      getPhotoName(photo) {
        const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
      },


      getDifferentDate(date1, date2){

            if (date1 == null) return null
            if (date2 == null) return null
            return moment(date1).diff(moment(date2), 'days')
 
        },




      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },

      includeNull(field){
            return field==null ? '' : field;
        },
     },
    }
</script>